import React from "react";
function MiniRing({value,max,color,size,label,sub,trackColor}){const r=(size-6)/2;const circ=2*Math.PI*r;const pct=max?value/max:0;return(
  <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:2}}>
    <svg width={size} height={size} style={{transform:"rotate(-90deg)"}}>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={trackColor||"var(--g100)"} strokeWidth="5"/>
      <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth="5" strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={circ*(1-pct)} style={{transition:"stroke-dashoffset .5s ease"}}/>
    </svg>
    <div style={{marginTop:-size/2-6,marginBottom:size/2-12,fontFamily:"var(--fm)",fontSize:size>50?14:11,fontWeight:700,color,textAlign:"center",lineHeight:1}}>{label}</div>
    {sub&&<div style={{fontFamily:"var(--fi)",fontSize:9,color:"var(--g400)",textAlign:"center",marginTop:2}}>{sub}</div>}
  </div>);}
export default MiniRing;
